import { useState } from 'react'
import { FileUploader } from 'react-drag-drop-files'

function DragDrop({
  setValue,
  children,
  hoverTitle = 'Drop here',
  name,
  fileTypes = ['JPG', 'PNG', 'JEPG'],
  customValue,
  onFileType,
  isMultiple = false,
}) {
  const [success] = useState('')
  const fieldName = customValue ?? name ?? 'logo'

  const handleChange = (file) => {
    const isMultiple = file?.FileList ? Object.keys(file?.FileList)?.length > 1 : file
    if (onFileType) onFileType(isMultiple)
    setValue(fieldName, file)
  }
  return (
    <FileUploader
      name={name}
      multiple={isMultiple}
      handleChange={handleChange}
      types={fileTypes}
      hoverTitle={hoverTitle}
      onTypeError={(err) => {
        setValue(fieldName, err)
      }}
    >
      {children}
      <span className="text-danger">{success}</span>
    </FileUploader>
  )
}

export default DragDrop
